import React from 'react';
import * as cls from './what-appliances.module.css';
import { Link } from 'react-router-dom';
import { Button } from '../../../../ui/components/button';
import { Section } from '../../../../ui/components/section';
import { Typography } from '../../../../ui/components/typography';

export const WhatAppliances = () => {
  return (
    <Section classNameRoot={cls.section}>
      <Typography as="h1" tag="h2">
        What Appliances Can Be Recognised?
      </Typography>

      <Typography>
        High-impact categories typically include heating & hot water,
        cooling/HVAC and pumps, EV charging, cooking, refrigeration, laundry and
        dishwashing, entertainment/IT, lighting, and more.
      </Typography>
      <Typography>
        Coverage varies by region, appliance mix, and data resolution, and
        expands as the appliance library grows.
      </Typography>

      <Link to="/support/disaggregation#how-many-appliances-can-be-disaggregated">
        <Button variant="green-transparent">See full list</Button>
      </Link>
    </Section>
  );
};
